import LoanSimulatorPage from "../../shared/LoanSimulatorPage";

const CustomerLoanSimulatorPage = () => <LoanSimulatorPage />;

export default CustomerLoanSimulatorPage;
